import Footer from "../../components/layout/Footer/Footer";
import Navbar from "../../components/layout/Navbar/Navbar";
import HeroSection from "./components/pages/HeroSection";
import WhySquaay from "./components/pages/WhySquaay";
import "./Home.css";


const Home = () => {
  return (
    <div className="home-container">
      <Navbar/>
      <HeroSection />
      <WhySquaay />
      <Footer />
    </div>
  );
};

export default Home;
